<svelte:head>
  <title>Settings | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->

{#if data}
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left">
      <div class="level-item">
        <h2 class="title">General settings</h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right"><button class="button">More actions</button></div>
  </nav>

  <article class="message is-info">
    <div class="message-body">
      <p>Settings that don't have a home elsewhere</p>
    </div>
  </article>

  {#if showToast}
    <div class="notification is-success">
      <button class="delete" on:click={() => (showToast = false)} />
      Settings updated
    </div>
  {/if}

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Default welcome message for new businesses (HTML)</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <textarea
            class="textarea"
            placeholder=""
            rows="10"
            bind:value={data.companyWelcomeMessage}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label">
      <!-- Left empty for spacing -->
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <button class="button is-primary" on:click={() => apply()}
            >Save</button
          >
        </div>
      </div>
    </div>
  </div>
{/if}

<script lang="ts">
  import _ from "lodash";

  let data :any;

  let showToast = false;

  let firebase = window.firebase;

  get();

  async function get() {
    await firebase
      .firestore()
      .collection('_config')
      .doc('general')
      .get()
      .then((doc) => {
        data = doc.data();
      });
  }

  async function apply() {
    let firebase = window.firebase;

    await firebase.firestore().collection('_config').doc('general').update(data);

    showToast = true;
  }
</script>
